import slStylesDark from './sl-dark.css';
import slStylesLight from './sl-light.css';

const darkStyleBodyClasses = ['wrs-dark'];
const isDark = () => {
  return darkStyleBodyClasses.reduce(
    (acc, bodyClass) => acc || document.body.classList.contains(bodyClass),
    false,
  );
};
const shoelaceStyles = isDark() ? slStylesDark : slStylesLight;
export default shoelaceStyles;
